"use strict";

define('app/print/abstract/print.abstract.controller',['rs/abstract.content.controller'], function (AbstractContentController) {
  var AbstractPrintController = AbstractContentController.extend({
    contentName: 'print-content',
    footer: false,
    feedback: false,
    viewIsReady: function viewIsReady() {
      this.getView().hideHeader();
      this._super();
    }
  });
  return AbstractPrintController;
});

